import React from 'react'
import SystemMessage from './SystemMessage'

export const MessageFreeChat = () => <SystemMessage text="freeChat"/>

export const MessageFreeChatCredits = () => <SystemMessage text="freeChatCredits"/>

export const MessageUpgrade = () => <SystemMessage text="upgrade"/>

export const MessageUpgradeCredits = ({ useMessagesInsteadOfCredits }) => <SystemMessage text={useMessagesInsteadOfCredits ? 'upgradeMessageCredits' : 'upgradeCredits'}/>


export const MessageLimit = () => <SystemMessage text="messageLimit"/>

export const MessageWarning = ({ isCorrespondent }) => <SystemMessage title="contactInfo" text={isCorrespondent ? 'userWarning' : 'otherUserWarning'}/>

export const TempMessage = ({ text, title }) => <SystemMessage text={text} title={title}/>
